import { createSlice, createAsyncThunk, createSelector } from "@reduxjs/toolkit";
import axios from "axios";
const APIURL = process.env.REACT_APP_API_URL_LOCAL;

export const fetchSettings = createAsyncThunk(
    "fetchSettings",
    async ({ headers, params }) => {
        const config = {
            headers: { ...headers },
            params: params
        }
        try {
            const data = await axios.get(`${APIURL}/settings/list`, config)
            return data

        } catch (error) {
            return error

        }
    }
);

export const fetchSettingDetail = createAsyncThunk(
    "fetchSettingDetail",
    async ({ headers, params }) => {
        const config = {
            headers: { ...headers }
        }
        try {
            const data = await axios.get(`${APIURL}/settings/view/${params.settingId}`, config)
            return data

        } catch (error) {
            return error

        }
    }
);

export const updateSetting = createAsyncThunk(
    "user/updateSetting",
    async (params, thunkAPI) => {
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            };

            const res = await axios.patch(
                `${APIURL}/settings/update/${params.id}`,
                params,
                config
            );

            return res.data; // ✅ This contains { message: "..." } from backend
        } catch (error) {
            // Optional: handle error properly
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || "Something went wrong"
            );
        }
    }
);

export const settingSlice = createSlice({
    name: "setting",
    initialState: {
        settings: [],
        total: 0,
        limit: 10,
        page: 1,
        settingDetail: {}
    },
    reducers: {
        changeLimit: (state, action) => {
            state.limit = action.payload;
        },
        changePage: (state, action) => {
            state.page = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchSettings.fulfilled, (state, action) => {
            if (action?.payload.status == 403) {
                localStorage.removeItem("token");
                localStorage.removeItem("userData");
            }
            if (action?.payload?.data?.success) {
                state.settings = action?.payload?.data?.result.settings;
                state.total = action?.payload?.data?.result.total;
            }
        });

        builder.addCase(fetchSettingDetail.fulfilled, (state, action) => {
            if (action?.payload.status == 403) {
                localStorage.removeItem("token");
                localStorage.removeItem("userData");
            }
            console.log(action)
            if (action?.payload?.data?.success) {
                state.settingDetail = action?.payload?.data?.result.setting;
            }
        });

    },
});

export const { changeLimit, changePage } = settingSlice.actions;
export default settingSlice.reducer;

export const settingSelector = createSelector(
    (state) => state.setting.settings,
    (state) => state.setting.total,
    (state) => state.setting.limit,
    (state) => state.setting.page,
    (state) => state.setting.settingDetail,
    (settings, total, limit, page, settingDetail) => ({
        settings, total, limit, page, settingDetail
    })
);

